/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, injectIntl } from 'react-intl';
import msgObject from '../../../../translations';
import IntlSupport from '../Localization/InternationalSupport';
import defaultThumbnailSrc from '../../../images/placeholder_thumbnail.png';
import Utilities from '../../util/Utilities';

const Thumbnail = (props) => {
  const intlObj = new IntlSupport(msgObject, props.locale);
  const defaultThumbnailAlt = intlObj.getMessages().thumbnailAlt;
  let cls = 'preview-image';
  if (props.classAttribute) {
    cls = `${cls} ${props.classAttribute}`;
  }
  if (props.imgCls) {
    cls = `${cls} ${props.imgCls}`;
  }

  const { contentURN, imageTitle } = props;
  const imgAlt = (props.data && props.data.alt) ? props.data.alt : defaultThumbnailAlt;
  const imgSrc = (props.data && props.data.src
    && ((props.data.src.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null)
    || (props && props.isAllowDataStringForImage
    && (props.data.src.toLowerCase().match(/data:image\/(jpeg|jpg|gif|png).*$/) != null))))
    ? props.data.src : defaultThumbnailSrc;
  const Wrapper = props.isImagePreview ? 'button' : 'div';
  const imgMarkup = (
    <Wrapper
      className="preview-image-wrapper"
      {...(
        (!props.data || !props.data.alt) &&
        imageTitle &&
        {
          'aria-label': Utilities.stripHtml(imageTitle)
        }
      )}
    >
      <img
        className={cls}
        alt={imgAlt || ''}
        src={imgSrc}
        onError={(e) => { e.target.src = defaultThumbnailSrc; }}
        {...((props.useCredentials || props.anonymous)
              && { crossOrigin: props.useCredentials ? 'use-credentials' : 'anonymous' })}
        data-contenturn={contentURN}
      />
    </Wrapper>
  );
  const finalElement = (<div>{imgMarkup}</div>);

  return (
    <IntlProvider locale={intlObj.getLocale()} messages={intlObj.getMessages()}>
      {finalElement}
    </IntlProvider>);
};

Thumbnail.propTypes = {
  data: PropTypes.shape({
    className: PropTypes.string,
    alt: PropTypes.string,
    src: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    height: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  }),
  locale: PropTypes.string,
  classAttribute: PropTypes.string,
  imgCls: PropTypes.string,
  useCredentials: PropTypes.bool,
  anonymous: PropTypes.bool,
  contentURN: PropTypes.string,
  isAllowDataStringForImage: PropTypes.bool,
  isImagePreview: PropTypes.bool,
  imageTitle: PropTypes.string
};

Thumbnail.defaultProps = {
  useCredentials: false,
  anonymous: false,
  isAllowDataStringForImage: false,
  isImagePreview: false,
  imageTitle: ''
};

export default injectIntl(Thumbnail);



// WEBPACK FOOTER //
// ./src/js/components/Thumbnail/Thumbnail.jsx